import { isClient } from "@travel/shared/utils";
export var APP_API_ROOT = isClient ? location.origin : "";
export var TRAVEL_API_ROOT = "https://".concat(process.env.NEXT_PUBLIC_APP_ENV === "production"
    ? "api-prod.getfeedz.com"
    : "ppn-feed.herokuapp.com");
export var TRAVEL_API_ROOT_LAMBDA = "https://".concat(process.env.NEXT_PUBLIC_APP_ENV === "production" ? "api-prod" : "dev", ".getfeedz.com");
